import { gql } from '@apollo/client';


export const GET_VEHICLE_INCIDENT_SPECIFICS = gql`
  query GET_VEHICLE_INCIDENT_SPECIFICS($incidentId: ID!, $originatorId: ID!){
    getVehicleIncidentSpecifics(incidentId: $incidentId, originatorId: $originatorId) {
      id
      uuid
      abandoned
      impounded
      evidenceStatus
      recoveredValue
      dateStolen
      dateRecovered
      incident {
        id
        uuid
      }
      operator {
        id
        personalAttribute {
          id
          firstName
          lastName
        }
      }
      position
      reasonSeized {
        id
        name
      }
      suspectDriven
      wrecker {
        id
        name
      }
      towingDestination {
        id
        name
      }
      usedInCrime
      vehicle {
        id
        uuid
        description
        owner {
          id
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        plateType {
          id
          name
        }
        value
        vehicleColor {
          id
          name
        }
        vehicleMake {
          id
          nhtsaId
          name
        }
        vehicleModel {
          id
          nhtsaId
          name
        }
        vehiclePlate {
          id
          name
        }
        vehicleState {
          id
          name
        }
        vehicleVin {
          id
          name
        }
        year
        validVehicleAlerts {
          alertType {
            id
            name
            alertLevel
            oriId
            position
          }
          expireAt
          id
          notes
          officerId
          vehicle {
            id
          }
        }
      }
      vehicleOfInterest
      vehicleRole {
        id
        name
      }
    }
  }
`;


